export default __webpack_public_path__ + "static/media/generic-form.d17aa635.svg";